module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-view"
  }, [_c('el-upload', {
    ref: "uploader",
    staticClass: "uploader-item-view",
    attrs: {
      "list-type": "picture-card",
      "accept": _vm.accept,
      "action": _vm.uploadApi,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "before-remove": _vm.beforeRemove,
      "on-exceed": _vm.handleExceed,
      "file-list": _vm.fileList,
      "limit": _vm.limit,
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "headers": _vm.headers
    }
  }, [_c('div', {
    staticClass: "icon-view"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "upload-tip-view"
  }, [_c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("请上传图片文件")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-34d5cf96", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34d5cf96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadImg/index.vue
// module id = 1277
// module chunks = 1